import { render, staticRenderFns } from "./print_IV.vue?vue&type=template&id=35539a29&scoped=true"
import script from "./print_IV.vue?vue&type=script&lang=js"
export * from "./print_IV.vue?vue&type=script&lang=js"
import style0 from "./print_IV.vue?vue&type=style&index=0&id=35539a29&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35539a29",
  null
  
)

export default component.exports